export default {
  Project: {
    Add: 'افزودن پروژه جدید',
    AddPart: 'افزودن پارت جدید',
    Edit: 'ویرایش پروژه جدید',
    Show: 'مشاهده اطلاعات پروژه',
    ShowExport: 'مشاهده خروجی پروژه',
    Confirm: 'تایید تغییر وضعیت',
    CustomerName: 'نام و نام خانوادگی مشتری',
    CustomerPhone: 'شماره تلفن مشتری',
    NicName: 'نام نماینده',
    ContractNumber: 'شماره قرارداد',
    CustomerCode: 'کد ملی مشتری',
    CustomerAddress: 'آدرس محل نصب پروژه',
    MapNumber: 'شماره نقشه',
    ApprovalNumber: 'مصوبه',
    ProfileType: 'نوع پروفیل',
    SendTo: 'ارسال به بخش',
    PartNumber: 'شماره پارت',
    DoorCount: 'تعداد درب',
    WindowCount: 'تعداد پنجره',
    fixCount: 'تعداد فیکس',
    ContractDate: 'تاریخ قرارداد',
    TotalPrice: 'مبلغ کل',
    PrePrice: 'پیش پرداخت',
    AddCheck: 'افزودن چک',
    PayWithCheck: 'پرداخت با چک',
    Meter: 'ابعاد بردار',
    WaitProvideShopList: 'تامین لیست خرید',
    WaitProduct: 'در انتظار تولید',
    EditInstaller: ' تغییر نصاب',
    AddInstaller: ' افزودن نصاب',
    AddMeter: ' افزودن ابعاد بردار',
    EditMeter: ' تغییر ابعاد بردار',
    ShopList: 'لیست خریداولیه',
    ContractDescription: 'توصیحات قرارداد(اختیاری)',
    ProjectReport: 'ایرادات گرفته شده توسط حسابداری',
    Delete: 'حذف پروژه',
    Status: 'فرآیند انجام پروژه',
    PayStatus: 'وضعیت کرایه',
    NextStep: 'مرحله بعدی',
    Repair: 'نیاز به ویرایش',
    ReportProblem: 'گزارش مشکل',
    projectDone: 'اتمام پروژه',
    projectDoneText: 'پروژه نیازی به نصب ندارد و اتمام شود.',
    ReportShortage: 'گزارش کمبود',
    ProjectNumber: 'شماره پروژه',
    CheckNumber: 'شماره چک',
    BankName: 'نام بانک',
    FileName: 'عنوان فایل',
    CheckPrice: 'مبلغ چک',
    AddFile: 'افزودن فایل',
    Export: 'خروج پروژه',
    AddAssistance: 'افزودن همکار مدیر فروش',
    CheckDate: 'تاریخ چک',
    OldStatus: 'وضعیت قبلی',
    NewStatus: 'وضعیت جدید',
    ChangedBy: 'تغییر توسط',
    ChangedDate: 'تاریخ تغییر',
    AccountantReport: 'گزارش مشکل',
    NeedToMeterStatusText: 'ابعاد برداری انجام شود.',
    DeleteItemConfirm: 'آیا از حذف این پروژه اطمینان دارید؟ بعد از حذف ممکن است بازیابی اطلاعات انجام پذیر نباشد.',
    Files: {
      Name: 'نام فایل',
      Date: 'تاریخ افزودن',
      Print: 'وضعیت پرینت',
    },
    Placeholder: {
      ReportShortage: 'لطفا کمبود های پروژه را یادداشت کنید.',
      FileName: 'عنوان فایل را وارد کنید.',
      NicName: 'نام نماینده را وارد کنید.',
      CheckNumber: 'شماره چک را وارد کنید.',
      BankName: ' نام بانک را وارد کنید.',
      ShopList: 'لیست خرید وجود دارد.',
      CustomerCode: 'کد ملی را وارد کنید.',
      CustomerAddress: 'آدرس را وارد کنید.',
      ContractNumber: 'شماره قرارداد را وارد کنید.',
      MapNumber: 'شماره نقشه را وارد کنید.',
      ApprovalNumber: 'شماره مصوبه را وارد کنید.',
      DoorCount: 'تعداد درب را وارد کنید.',
      WindowCount: 'تعداد درب را وارد کنید.',
      fixCount: 'تعداد فیکس را وارد کنید.',
      ContractDate: 'تاریخ را وارد کنید.',
      TotalPrice: 'مبلغ را وارد کنید.',
      PrePrice: 'پیش پرداخت را وارد کنید.',
      AccountantReport: 'لطفا توضیح کوتاهی درباره علت تایید نکردن اطلاعات مالی پروژه یادداشت کنید.',
    },
    ConfirmModal: {
      Text: 'توجه : پس از تایید، دیگر امکان برگشت به مرحله قبل وجود نخواهد داشت.',
    },
    MeterInfo: {
      Name: 'نام ابعاد بردار',
      AddDate: 'تاریخ اعلام',
      EndDate: 'تاریخ پایان',
      Status: 'وضعیت',
    },
    InstallerInfo: {
      Name: 'نام نصاب',
      AddDate: 'تاریخ اعلام',
      EndDate: 'تاریخ پایان',
      Status: 'وضعیت نصب',
    },
    ProjectPayStatus: {
      pay: 'دریافت شود',
      free: 'دریافت نشود',
      pay_customer: 'حمل توسط مشتری',
    },
    AllStatus: {
      Start: 'ایجاد پروژه',
      Repiar: 'نیاز به بررسی مجدد',
      Contract: 'ثبت قرارداد',
      WaitApproveFinancialStatus: 'تایید مالی',
      WaitProvideShopList: 'تامین لیست خرید',
      WaitApproveFinancial: 'حسابداری',
      WaitApproveAdmin: 'تایید مدیریت',
      WaitAddMeter: 'افزودن ابعادبردار',
      WaitToSendForMeter: 'بررسی مدیرفروش',
      InMeter: 'ابعادبرداری',
      AddPdfData: 'افزودن فایل ها',
      WaitToProduction: 'درانتظار تولید',
      ShortageInProduction: 'اعلام کمبود',
      InProduction: 'در حال تولید',
      ReadyToInstall: 'آماده نصب',
      ReadyToExport: 'خروج پروژه',
      InInstall: 'در حال نصب',
      DoneInstall: 'اتمام نصب',
      RepiarInstall: 'بررسی مجدد مدیر نصب',
      FinalReceipt: 'صورت وضعیت',
      WaitEndApproveFinancial: 'تایید و پرداخت',
      Finish: 'اتمام پروژه',
      Archive: 'آرشیو',
    },
  },
}
